// Externe Bibliotheken
import React, { Component } from 'react';
import { NavLink } from 'react-router';
import axios from 'axios';

// Interne Module
import * as storage from '@/_helper/storage';
import tracking from '@/_helper/tracking';
import { getBookingData } from '@/_helper/fetchNewData';

// Komponenten
import Header from '@/comp/header/Header';
import Footer from '@/comp/footer/Footer';
import { BackButton } from '@/comp/backButton/backButton';
import Button from '@/comp/button/button';
import PhoneInput from '@/comp/form/phoneInput/PhoneInput';
import StatusPage from '@/comp/statusPage/statusPage';

// Styles
import './digital-tour-guide.scss';

const params = {
    errorWording: {
        firstName: 'Bitte geben Sie Ihren Vornamen an.',
        lastName: 'Bitte geben Sie Ihren Nachnamen an.',
        mobileNumber: {
            default: 'Bitte geben Sie Ihre Telefonnummer an.',
            number: 'Die Mobilnummer ist leider nicht korrekt. Bitte überprüfen Sie Ihre Eingabe.',
            landline: 'Festnetznummern sind zur Anmeldung nicht möglich, bitte geben Sie eine Mobilnummer ein.',
        },
        accept: 'Um das Formular abschicken zu können, müssen Sie beiden Bedingungen zustimmen.',
    },
    checkboxes: [
        {
            checked: false,
            text: (
                <>
                    Ich stimme der Kontaktaufnahme von AurumTours und der Datenverarbeitung über WhatsApp zu. Außerdem
                    akzeptiere ich die{' '}
                    <a href={`${window.$website}/unternehmen/agb`} target="_blank" rel="noopener noreferrer">
                        AGBs
                    </a>{' '}
                    und{' '}
                    <NavLink to="/datenschutz" target="_blank">
                        Datenschutzhinweise
                    </NavLink>{' '}
                    von AurumTours und habe die{' '}
                    <a href="https://www.sinch.com/de-de/privacy-policy/" target="_blank" rel="noopener noreferrer">
                        Datenschutzhinweise
                    </a>{' '}
                    von Sinch (Messenger People GmbH) zur Kenntnis genommen.
                </>
            ),
        },
        {
            checked: false,
            text: (
                <>
                    Um Sie während Ihres Urlaubs kontaktieren zu können und Ihre Anfragen über WhatsApp zu beantworten,
                    kooperieren wir mit Sinch (Messenger People GmbH). Durch die Aktivierung der digitalen Reiseleitung
                    sind Sie damit einverstanden, dass die AurumTours GmbH für die Bearbeitung personenbezogene Daten
                    (wie z.B. Ihre Telefonnummer, Ihre Vorgangsnummer usw.) verarbeitet.
                </>
            ),
        },
    ],
};

class Index extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            pageLoad: false,
            bookingData: storage.get('bookingData') !== null ? storage.get('bookingData') : {},
            bookingParams:
                storage.get('bookingData') !== null && storage.get('bookingData').bookingParams !== undefined
                    ? storage.get('bookingData').bookingParams
                    : '',
            checkboxes: params.checkboxes,
            country: 'DE',
            firstName: '',
            lastName: '',
            mobileNumber: '',
            formErrors: {
                firstName: params.errorWording.firstName,
                lastName: params.errorWording.lastName,
                mobileNumber: params.errorWording.mobileNumber.default,
                accept: params.errorWording.accept,
            },
            error: null,
            alreadyTested: false,
            acceptValid: false,
            firstNameValid: false,
            lastNameValid: false,
            mobileNumberValid: false,
            formValid: false,
            formVacancy: false,
            responseCase: false,
            responseCaseConfig: {
                success: false,
                condition: 1,
            },
        };

        this.handleUserInput = this.handleUserInput.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.setMobileNumber = this.setMobileNumber.bind(this);
    }

    componentDidMount() {
        document.querySelector('html').classList.add('redesign');

        document.title = 'Ihre digitale Reiseleitung' + window.$documentTitle;

        const { allowDigitalTourGuide, tourGuideData } = this.state.bookingData.data;

        // not allowed to book
        if (
            allowDigitalTourGuide === undefined ||
            allowDigitalTourGuide === false ||
            (tourGuideData?.registered !== undefined && tourGuideData?.registered === true)
        ) {
            window.location.href = '#/';
        } else {
            tracking('loaded', 'tourGuide');
        }
    }

    resetTrigger(element) {
        const handleClick = (event, element) => {
            this.setState({ [element]: '' });
            this.validateField(element, '');
            event.target.closest('input').focus();
        };

        if (this.state[element].length > 0) {
            return (
                <div className="reset-trigger" onClick={(event) => handleClick(event, element)}>
                    <i className="material-symbols-outlined">clear</i>
                </div>
            );
        }
    }

    handleUserInput(event) {
        const target = event.target;
        let value = target.value;
        const name = target.name;

        this.setState({ [name]: value }, () => {
            this.validateField(name, value);
        });
    }

    handleCheckboxChange(index) {
        const fieldValidationErrors = this.state.formErrors;
        const checkboxes = this.state.checkboxes;
        checkboxes[index].checked = !checkboxes[index].checked;

        const acceptValid = checkboxes.every((item) => item.checked);

        if (!acceptValid) {
            fieldValidationErrors.accept = params.errorWording.accept;
        } else {
            fieldValidationErrors.accept = '';
        }

        this.setState(
            {
                checkboxes: checkboxes,
                acceptValid: acceptValid,
                formErrors: fieldValidationErrors,
            },
            this.validateForm
        );
    }

    setMobileNumber(numberParts) {
        const fieldValidationErrors = this.state.formErrors;

        const mobileNumber = numberParts !== undefined && {
            phoneCountryCode: numberParts.phoneCountryCode ?? '',
            phoneCountryPrefix: numberParts.phoneCountryPrefix ?? '',
            phoneAreaCode: numberParts.phoneAreaCode ?? '',
            phoneNumber: numberParts.phoneNumber ?? '',
            lengthValid: numberParts.lengthValid ?? false,
            isLandline: numberParts.isLandline ?? false,
        };

        // set error message
        if (mobileNumber?.isLandline) {
            fieldValidationErrors.mobileNumber = params.errorWording.mobileNumber.landline;
        } else if (!mobileNumber?.lengthValid) {
            fieldValidationErrors.mobileNumber = params.errorWording.mobileNumber.number;
        } else if (!mobileNumber?.isLandline && mobileNumber?.lengthValid) {
            fieldValidationErrors.mobileNumber = '';
        }

        this.setState(
            {
                mobileNumber: mobileNumber,
                mobileNumberValid: !mobileNumber?.isLandline && mobileNumber?.lengthValid,
                formErrors: fieldValidationErrors,
            },
            this.validateForm
        );
    }

    validateField(fieldName, value) {
        const fieldValidationErrors = this.state.formErrors;
        let firstNameValid = this.state.firstNameValid;
        let lastNameValid = this.state.lastNameValid;

        if (fieldName === 'firstName') {
            firstNameValid = value.length > 0;
            fieldValidationErrors.firstName = firstNameValid ? '' : params.errorWording.firstName;
        } else if (fieldName === 'lastName') {
            lastNameValid = value.length > 0;
            fieldValidationErrors.lastName = lastNameValid ? '' : params.errorWording.lastName;
        }

        this.setState(
            {
                formErrors: fieldValidationErrors,
                firstNameValid: firstNameValid,
                lastNameValid: lastNameValid,
            },
            this.validateForm
        );
    }

    validateForm() {
        this.setState({
            formValid:
                this.state.acceptValid &&
                this.state.firstNameValid &&
                this.state.lastNameValid &&
                this.state.mobileNumberValid,
        });
    }

    handleSubmit(event) {
        event.preventDefault();

        this.setState({
            error: false,
            alreadyTested: true,
        });

        // return if invalid
        if (!this.state.formValid) {
            return;
        }

        const fullMobileNumber =
            this.state.mobileNumber.phoneCountryPrefix +
            this.state.mobileNumber.phoneAreaCode +
            this.state.mobileNumber.phoneNumber;

        const sendData = {
            clientId: 'customerarea',
            forename: this.state.firstName,
            surname: this.state.lastName,
            country: this.state.mobileNumber.phoneCountryCode,
            mobile: fullMobileNumber,
            bookingNumber: storage.get('bookingNumber'),
        };

        this.setState({ formVacancy: true });

        axios({
            url: window.$tourGuideRegistrationUrl,
            method: 'POST',
            headers: { 'content-type': 'application/json' },
            data: JSON.stringify(sendData),
        })
            .then((response) => response)
            .then((response) => {
                const success = response.data.success;
                const errorCode = response.data.errorCode;

                if (success) {
                    const responseCaseConfig = this.state.responseCaseConfig;

                    responseCaseConfig.success = !errorCode;
                    responseCaseConfig.condition = errorCode;

                    const handleSuccess = () =>
                        this.setState({
                            formVacancy: false,
                            responseCase: true,
                            responseCaseConfig: responseCaseConfig,
                        });

                    getBookingData(storage.get('access_token'))
                        .then(() => handleSuccess())
                        .catch(() => handleSuccess());
                } else {
                    // set error dialogs
                    const fieldValidationErrors = this.state.formErrors;
                    const errors = response.data?.messages;

                    for (const key in errors) {
                        if (errors.hasOwnProperty(key)) {
                            if (key === 'bookingNumber') {
                                continue;
                            }
                            switch (key) {
                                case 'forename':
                                    fieldValidationErrors.firstName = errors[key];
                                    break;
                                case 'surname':
                                    fieldValidationErrors.lastName = errors[key];
                                    break;
                                case 'mobile':
                                    fieldValidationErrors.mobileNumber = errors[key];
                                    break;
                                default:
                            }

                            this.setState({
                                formErrors: fieldValidationErrors,
                            });
                        }
                    }
                }
            })
            .catch((error) => {
                this.setState({ formVacancy: false });

                // set error dialogs
                const fieldValidationErrors = this.state.formErrors;

                if (error.response?.data?.messages) {
                    const errors = error.response?.data?.messages;

                    for (const key in errors) {
                        if (key === 'bookingNumber') {
                            continue;
                        }

                        switch (key) {
                            case 'forename':
                                fieldValidationErrors.firstName = errors[key];
                                break;
                            case 'surname':
                                fieldValidationErrors.lastName = errors[key];
                                break;
                            case 'mobile':
                                fieldValidationErrors.mobileNumber = errors[key];
                                break;
                            default:
                        }

                        this.setState({
                            formErrors: fieldValidationErrors,
                        });
                    }
                } else {
                    this.setState({ error, formVacancy: false });
                }
            });
    }

    responseCase() {
        const config = this.state.responseCaseConfig;

        if (config.success) {
            return <StatusPage type="success" subPage={'tourGuide'} />;
        } else {
            return <StatusPage type="error" case={config.condition ?? ['default']} subPage={'tourGuide'} />;
        }
    }

    render() {
        const textInputsValid = this.state.firstNameValid && this.state.lastNameValid && this.state.mobileNumberValid;

        return (
            <div className="page-digital-tour-guide">
                <Header />

                {this.state.responseCase ? (
                    this.responseCase()
                ) : (
                    <div className="content-wrapper">
                        <h1 className="main-headline">Ihre digitale Reiseleitung</h1>
                        <div className="intro-row">
                            Wir freuen uns, dass Sie unsere digitale Reiseleitung über WhatsApp nutzen möchten. Damit
                            wir den Service für Sie aktivieren können, benötigen wir Ihre Kontaktdaten.
                        </div>
                        <div className="messenger-alert">
                            <i className="material-symbols-outlined">info</i>
                            Bitte prüfen Sie, ob der Nachrichtendienst WhatsApp auf Ihrem Mobiltelefon installiert ist.
                            Dies ist Vorraussetzung für die Benutzung der digitalen Reiseleitung.
                        </div>

                        <form
                            className={this.state.formVacancy ? 'validate' : ''}
                            autoComplete="on"
                            onSubmit={this.handleSubmit}
                            onChange={() => tracking('interaction', 'tourGuide')}>
                            <section className={`card${textInputsValid ? ' valid' : ''}`}>
                                <div
                                    className={`card-row${
                                        this.state.alreadyTested && !this.state.firstNameValid ? ' input-error' : ''
                                    }`}>
                                    <label htmlFor="firstName">Vorname</label>
                                    <input
                                        id="firstName"
                                        name="firstName"
                                        type="text"
                                        value={this.state.firstName}
                                        onChange={(event) => {
                                            this.handleUserInput(event);
                                        }}
                                    />

                                    {this.resetTrigger('firstName')}

                                    {this.state.alreadyTested && this.state.formErrors.firstName.length > 0 && (
                                        <div className="error">{this.state.formErrors.firstName}</div>
                                    )}
                                </div>

                                <div
                                    className={`card-row${
                                        this.state.alreadyTested && !this.state.lastNameValid ? ' input-error' : ''
                                    }`}>
                                    <label htmlFor="lastName">Nachname</label>
                                    <input
                                        id="lastName"
                                        name="lastName"
                                        type="text"
                                        value={this.state.lastName}
                                        onChange={(event) => {
                                            this.handleUserInput(event);
                                        }}
                                    />

                                    {this.resetTrigger('lastName')}

                                    {this.state.alreadyTested && this.state.formErrors.lastName.length > 0 && (
                                        <div className="error">{this.state.formErrors.lastName}</div>
                                    )}
                                </div>

                                <div
                                    className={`card-row mobile-number${
                                        this.state.alreadyTested && !this.state.mobileNumberValid ? ' input-error' : ''
                                    }`}>
                                    <PhoneInput label="Mobilnummer" setMobileNumber={this.setMobileNumber} />
                                    <i className="material-symbols-outlined tooltip-icon">
                                        info
                                        <div className="tooltip">
                                            Bitte achten Sie auf die Richtigkeit der angegebenen Mobiltelefonnummer, um
                                            sicherzustellen, dass unsere digitale Reiseleitung Sie vor Ort erreichen
                                            kann.
                                        </div>
                                    </i>
                                    {this.state.alreadyTested && this.state.formErrors.mobileNumber.length > 0 && (
                                        <div className="error">{this.state.formErrors.mobileNumber}</div>
                                    )}
                                </div>
                            </section>

                            <section className="accept-sec">
                                {this.state.checkboxes.map((item, index) => {
                                    return (
                                        <div className="accept-sec-row" key={index}>
                                            <input
                                                id={`accept-${index}`}
                                                name={`accept-${index}`}
                                                type="checkbox"
                                                checked={item.checked}
                                                onChange={() => this.handleCheckboxChange(index)}
                                            />
                                            <label htmlFor={`accept-${index}`}>{item.text}</label>
                                        </div>
                                    );
                                })}
                                {this.state.alreadyTested && this.state.formErrors.accept.length > 0 && (
                                    <div className="error">{this.state.formErrors.accept}</div>
                                )}
                            </section>

                            <div className="user-action">
                                <BackButton target="blank" />
                                <Button
                                    type="submit"
                                    label={
                                        !this.state.formVacancy
                                            ? 'Kontaktdaten abschicken'
                                            : 'Daten werden übermittelt ...'
                                    }
                                    icon="arrow_forward"
                                    valid={this.state.formValid}
                                    validated={this.state.formVacancy}
                                />
                            </div>
                            {this.state.error === true && (
                                <div className={'error txtR'}>{window.$content.errorText}</div>
                            )}
                            {this.state.error !== true &&
                                Array.isArray(this.state.error) &&
                                this.state.error.map((e, i) => {
                                    return (
                                        <div key={i} className={'error txtR'}>
                                            {e}
                                        </div>
                                    );
                                })}
                        </form>
                    </div>
                )}

                <Footer />
            </div>
        );
    }
}

export default Index;
